export * from './IconMetal';
export { default as IconMetal } from './IconMetal';
